import { createSlice } from '@reduxjs/toolkit';

import { updateBoxSplitStatus, splittedBoxDetails, closeBin, scanSku, switchFacilityLoad } from "./api";
import { act } from 'react';

export const splittingPlatform = createSlice({
  name: "splittingPlatform",
  initialState: {
    loading: false,
    error: "",
    getSplittingData: [],
    getSkusData: [],
    updateBoxSplitStatusSuccess: false,
    closeBinSuccessSuccess: false,
    scanSkuSuccess: false,
    switchFacilityLoadSuccessMessage: '',
    scanSkuWarehouse : ''
  },
  reducers: {
    clearErrors: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(splittedBoxDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(splittedBoxDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.getSplittingData = action.payload.data;
    });
    builder.addCase(splittedBoxDetails.rejected, (state, action) => {
      console.error('splittedBoxDetails splitting platform api', state, action)
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(updateBoxSplitStatus.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateBoxSplitStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.updateBoxSplitStatusSuccess = true;
    });
    builder.addCase(updateBoxSplitStatus.rejected, (state, action) => {
      console.error('updateBoxSplitStatus splitting platform api', state, action)
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(closeBin.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(closeBin.fulfilled, (state, action) => {
      state.loading = false;
      state.closeBinSuccessSuccess = true;
    });
    builder.addCase(closeBin.rejected, (state, action) => {
      console.error('closeBin splitting platform api', state, action)
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(scanSku.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(scanSku.fulfilled, (state, action) => {
      state.loading = false;
      state.scanSkuSuccess = true;
      state.scanSkuWarehouse = action.payload.data.message;
    });
    builder.addCase(scanSku.rejected, (state, action) => {
      console.error('scanSku splitting platform api', state, action)
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(switchFacilityLoad.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(switchFacilityLoad.fulfilled, (state, action) => {
      state.loading = false;
      state.switchFacilityLoadSuccessMessage = action.payload.data.message;
    });
    builder.addCase(switchFacilityLoad.rejected, (state, action) => {
      console.error('switchFacilityLoad splitting platform api', state, action)
      state.error = action.payload.message;
      state.loading = false;
    });
    
  },
});

export const { clearErrors } = splittingPlatform.actions;

export default splittingPlatform.reducer;